/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * ExodusAdv API
 * OpenAPI spec version: 1.0.0
 */
import type {
  ApprovalListResponse,
  AppsAdvApiRouterCreateEvent400,
  AppsAdvApiRouterCreateRide400,
  AppsAdvApiRouterGetFeaturedRally200,
  AppsAdvApiRouterListProfilesParams,
  AppsAdvApiRouterListRidesParams,
  AppsAdvApiRouterUploadImageBody,
  AppsBillingApiSubscriptionsGetPortalUrlParams,
  AppsCoreApiRouterCreateRichContent400,
  AppsCoreApiRouterListRichContentParams,
  AppsUserApiRouterEarlySignupParams,
  AppsUserApiRouterLoginView400,
  AppsUserApiRouterLoginView403,
  AppsUserApiRouterRegisterView400,
  AppsUserApiRouterUpdateProfile400,
  CheckoutSessionRequest,
  CheckoutSessionResponse,
  ConnectOnboardingRequest,
  ConnectOnboardingResponse,
  ErrorResponse,
  EventCreate,
  EventOut,
  EventUpdate,
  FeaturedContentCreate,
  FeaturedContentOut,
  FeaturedContentUpdate,
  ImageUploadResponse,
  LoginIn,
  LoginResponse,
  MessageResponse,
  PaginatedEventResponse,
  PaginatedMyRidesRSVPsResponse,
  PaginatedRSVPResponse,
  PaginatedRideResponse,
  PortalUrlResponse,
  ProfileUpdateResponse,
  RSVPListResponse,
  RSVPStatusResponse,
  RallyTicketCheckoutRequest,
  RallyTicketCheckoutResponse,
  RateRideIn,
  RateRideResponse,
  RefundResponse,
  RegisterIn,
  RegisterResponse,
  ReorderIn,
  RichContentCreate,
  RichContentDetailOut,
  RichContentListOut,
  RichContentUpdate,
  RideCreate,
  RideOut,
  RideUpdate,
  SessionResponse,
  TicketListResponse,
  TicketQRUrlResponse,
  TicketWithEventResponse,
  ToggleFeaturedIn,
  TrackDownloadResponse,
  TrackProcessRequest,
  TrackResponse,
  TrackUpdateRequest,
  TrackUploadUrlResponse,
  UserOut,
  UserUpdate,
  WaitlistListResponse,
  WaitlistStatusResponse,
} from "./models";

import { customFetch } from "../custom-fetch";
/**
 * Login with email and password.
Returns user data on success.
 * @summary Login View
 */
export type appsUserApiRouterLoginViewResponse200 = {
  data: LoginResponse;
  status: 200;
};

export type appsUserApiRouterLoginViewResponse400 = {
  data: AppsUserApiRouterLoginView400;
  status: 400;
};

export type appsUserApiRouterLoginViewResponse403 = {
  data: AppsUserApiRouterLoginView403;
  status: 403;
};

export type appsUserApiRouterLoginViewResponseSuccess =
  appsUserApiRouterLoginViewResponse200 & {
    headers: Headers;
  };
export type appsUserApiRouterLoginViewResponseError = (
  | appsUserApiRouterLoginViewResponse400
  | appsUserApiRouterLoginViewResponse403
) & {
  headers: Headers;
};

export type appsUserApiRouterLoginViewResponse =
  | appsUserApiRouterLoginViewResponseSuccess
  | appsUserApiRouterLoginViewResponseError;

export const getAppsUserApiRouterLoginViewUrl = () => {
  return `/api/auth/login/`;
};

export const appsUserApiRouterLoginView = async (
  loginIn: LoginIn,
  options?: RequestInit,
): Promise<appsUserApiRouterLoginViewResponse> => {
  return customFetch<appsUserApiRouterLoginViewResponse>(
    getAppsUserApiRouterLoginViewUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(loginIn),
    },
  );
};

/**
 * Register a new user account.
Sends verification email on success.
 * @summary Register View
 */
export type appsUserApiRouterRegisterViewResponse200 = {
  data: RegisterResponse;
  status: 200;
};

export type appsUserApiRouterRegisterViewResponse400 = {
  data: AppsUserApiRouterRegisterView400;
  status: 400;
};

export type appsUserApiRouterRegisterViewResponseSuccess =
  appsUserApiRouterRegisterViewResponse200 & {
    headers: Headers;
  };
export type appsUserApiRouterRegisterViewResponseError =
  appsUserApiRouterRegisterViewResponse400 & {
    headers: Headers;
  };

export type appsUserApiRouterRegisterViewResponse =
  | appsUserApiRouterRegisterViewResponseSuccess
  | appsUserApiRouterRegisterViewResponseError;

export const getAppsUserApiRouterRegisterViewUrl = () => {
  return `/api/auth/register/`;
};

export const appsUserApiRouterRegisterView = async (
  registerIn: RegisterIn,
  options?: RequestInit,
): Promise<appsUserApiRouterRegisterViewResponse> => {
  return customFetch<appsUserApiRouterRegisterViewResponse>(
    getAppsUserApiRouterRegisterViewUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(registerIn),
    },
  );
};

/**
 * Logout the current user.
 * @summary Logout View
 */
export type appsUserApiRouterLogoutViewResponse200 = {
  data: MessageResponse;
  status: 200;
};

export type appsUserApiRouterLogoutViewResponseSuccess =
  appsUserApiRouterLogoutViewResponse200 & {
    headers: Headers;
  };
export type appsUserApiRouterLogoutViewResponse =
  appsUserApiRouterLogoutViewResponseSuccess;

export const getAppsUserApiRouterLogoutViewUrl = () => {
  return `/api/auth/logout/`;
};

export const appsUserApiRouterLogoutView = async (
  options?: RequestInit,
): Promise<appsUserApiRouterLogoutViewResponse> => {
  return customFetch<appsUserApiRouterLogoutViewResponse>(
    getAppsUserApiRouterLogoutViewUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

/**
 * Check if user is authenticated and return user data.
 * @summary Session View
 */
export type appsUserApiRouterSessionViewResponse200 = {
  data: SessionResponse;
  status: 200;
};

export type appsUserApiRouterSessionViewResponseSuccess =
  appsUserApiRouterSessionViewResponse200 & {
    headers: Headers;
  };
export type appsUserApiRouterSessionViewResponse =
  appsUserApiRouterSessionViewResponseSuccess;

export const getAppsUserApiRouterSessionViewUrl = () => {
  return `/api/auth/session/`;
};

export const appsUserApiRouterSessionView = async (
  options?: RequestInit,
): Promise<appsUserApiRouterSessionViewResponse> => {
  return customFetch<appsUserApiRouterSessionViewResponse>(
    getAppsUserApiRouterSessionViewUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Check if user is authenticated (no cache).
Same as session endpoint but with cache disabled.
 * @summary Check Session
 */
export type appsUserApiRouterCheckSessionResponse200 = {
  data: SessionResponse;
  status: 200;
};

export type appsUserApiRouterCheckSessionResponseSuccess =
  appsUserApiRouterCheckSessionResponse200 & {
    headers: Headers;
  };
export type appsUserApiRouterCheckSessionResponse =
  appsUserApiRouterCheckSessionResponseSuccess;

export const getAppsUserApiRouterCheckSessionUrl = () => {
  return `/api/auth/check-session/`;
};

export const appsUserApiRouterCheckSession = async (
  options?: RequestInit,
): Promise<appsUserApiRouterCheckSessionResponse> => {
  return customFetch<appsUserApiRouterCheckSessionResponse>(
    getAppsUserApiRouterCheckSessionUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Get the current user's profile.
 * @summary Get Profile
 */
export type appsUserApiRouterGetProfileResponse200 = {
  data: UserOut;
  status: 200;
};

export type appsUserApiRouterGetProfileResponseSuccess =
  appsUserApiRouterGetProfileResponse200 & {
    headers: Headers;
  };
export type appsUserApiRouterGetProfileResponse =
  appsUserApiRouterGetProfileResponseSuccess;

export const getAppsUserApiRouterGetProfileUrl = () => {
  return `/api/auth/profile/`;
};

export const appsUserApiRouterGetProfile = async (
  options?: RequestInit,
): Promise<appsUserApiRouterGetProfileResponse> => {
  return customFetch<appsUserApiRouterGetProfileResponse>(
    getAppsUserApiRouterGetProfileUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Update the current user's profile (partial update).
 * @summary Update Profile
 */
export type appsUserApiRouterUpdateProfileResponse200 = {
  data: ProfileUpdateResponse;
  status: 200;
};

export type appsUserApiRouterUpdateProfileResponse400 = {
  data: AppsUserApiRouterUpdateProfile400;
  status: 400;
};

export type appsUserApiRouterUpdateProfileResponseSuccess =
  appsUserApiRouterUpdateProfileResponse200 & {
    headers: Headers;
  };
export type appsUserApiRouterUpdateProfileResponseError =
  appsUserApiRouterUpdateProfileResponse400 & {
    headers: Headers;
  };

export type appsUserApiRouterUpdateProfileResponse =
  | appsUserApiRouterUpdateProfileResponseSuccess
  | appsUserApiRouterUpdateProfileResponseError;

export const getAppsUserApiRouterUpdateProfileUrl = () => {
  return `/api/auth/profile/`;
};

export const appsUserApiRouterUpdateProfile = async (
  userUpdate: UserUpdate,
  options?: RequestInit,
): Promise<appsUserApiRouterUpdateProfileResponse> => {
  return customFetch<appsUserApiRouterUpdateProfileResponse>(
    getAppsUserApiRouterUpdateProfileUrl(),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(userUpdate),
    },
  );
};

/**
 * Early signup with just email address.
 * @summary Early Signup
 */
export type appsUserApiRouterEarlySignupResponse201 = {
  data: MessageResponse;
  status: 201;
};

export type appsUserApiRouterEarlySignupResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsUserApiRouterEarlySignupResponse409 = {
  data: ErrorResponse;
  status: 409;
};

export type appsUserApiRouterEarlySignupResponseSuccess =
  appsUserApiRouterEarlySignupResponse201 & {
    headers: Headers;
  };
export type appsUserApiRouterEarlySignupResponseError = (
  | appsUserApiRouterEarlySignupResponse400
  | appsUserApiRouterEarlySignupResponse409
) & {
  headers: Headers;
};

export type appsUserApiRouterEarlySignupResponse =
  | appsUserApiRouterEarlySignupResponseSuccess
  | appsUserApiRouterEarlySignupResponseError;

export const getAppsUserApiRouterEarlySignupUrl = (
  params?: AppsUserApiRouterEarlySignupParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/early-signup/?${stringifiedParams}`
    : `/api/early-signup/`;
};

export const appsUserApiRouterEarlySignup = async (
  params?: AppsUserApiRouterEarlySignupParams,
  options?: RequestInit,
): Promise<appsUserApiRouterEarlySignupResponse> => {
  return customFetch<appsUserApiRouterEarlySignupResponse>(
    getAppsUserApiRouterEarlySignupUrl(params),
    {
      ...options,
      method: "POST",
    },
  );
};

/**
 * Resend verification email to the authenticated user.
Rate limited to once every 3 minutes per user.
 * @summary Resend Verification Email View
 */
export type appsUserApiRouterResendVerificationEmailViewResponse200 = {
  data: MessageResponse;
  status: 200;
};

export type appsUserApiRouterResendVerificationEmailViewResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsUserApiRouterResendVerificationEmailViewResponse429 = {
  data: ErrorResponse;
  status: 429;
};

export type appsUserApiRouterResendVerificationEmailViewResponseSuccess =
  appsUserApiRouterResendVerificationEmailViewResponse200 & {
    headers: Headers;
  };
export type appsUserApiRouterResendVerificationEmailViewResponseError = (
  | appsUserApiRouterResendVerificationEmailViewResponse400
  | appsUserApiRouterResendVerificationEmailViewResponse429
) & {
  headers: Headers;
};

export type appsUserApiRouterResendVerificationEmailViewResponse =
  | appsUserApiRouterResendVerificationEmailViewResponseSuccess
  | appsUserApiRouterResendVerificationEmailViewResponseError;

export const getAppsUserApiRouterResendVerificationEmailViewUrl = () => {
  return `/api/resend-verification-email/`;
};

export const appsUserApiRouterResendVerificationEmailView = async (
  options?: RequestInit,
): Promise<appsUserApiRouterResendVerificationEmailViewResponse> => {
  return customFetch<appsUserApiRouterResendVerificationEmailViewResponse>(
    getAppsUserApiRouterResendVerificationEmailViewUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

/**
 * List all user profiles, optionally filtered by username.
 * @summary List Profiles
 */
export type appsAdvApiRouterListProfilesResponse200 = {
  data: UserOut[];
  status: 200;
};

export type appsAdvApiRouterListProfilesResponseSuccess =
  appsAdvApiRouterListProfilesResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterListProfilesResponse =
  appsAdvApiRouterListProfilesResponseSuccess;

export const getAppsAdvApiRouterListProfilesUrl = (
  params?: AppsAdvApiRouterListProfilesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/profiles/?${stringifiedParams}`
    : `/api/profiles/`;
};

export const appsAdvApiRouterListProfiles = async (
  params?: AppsAdvApiRouterListProfilesParams,
  options?: RequestInit,
): Promise<appsAdvApiRouterListProfilesResponse> => {
  return customFetch<appsAdvApiRouterListProfilesResponse>(
    getAppsAdvApiRouterListProfilesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Get a user profile by username or ID.
 * @summary Get Profile
 */
export type appsAdvApiRouterGetProfileResponse200 = {
  data: UserOut;
  status: 200;
};

export type appsAdvApiRouterGetProfileResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterGetProfileResponseSuccess =
  appsAdvApiRouterGetProfileResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterGetProfileResponseError =
  appsAdvApiRouterGetProfileResponse404 & {
    headers: Headers;
  };

export type appsAdvApiRouterGetProfileResponse =
  | appsAdvApiRouterGetProfileResponseSuccess
  | appsAdvApiRouterGetProfileResponseError;

export const getAppsAdvApiRouterGetProfileUrl = (username: string) => {
  return `/api/profiles/${username}/`;
};

export const appsAdvApiRouterGetProfile = async (
  username: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterGetProfileResponse> => {
  return customFetch<appsAdvApiRouterGetProfileResponse>(
    getAppsAdvApiRouterGetProfileUrl(username),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Get events created by a user (by username or ID).
 * @summary Get Profile Events
 */
export type appsAdvApiRouterGetProfileEventsResponse200 = {
  data: EventOut[];
  status: 200;
};

export type appsAdvApiRouterGetProfileEventsResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterGetProfileEventsResponseSuccess =
  appsAdvApiRouterGetProfileEventsResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterGetProfileEventsResponseError =
  appsAdvApiRouterGetProfileEventsResponse404 & {
    headers: Headers;
  };

export type appsAdvApiRouterGetProfileEventsResponse =
  | appsAdvApiRouterGetProfileEventsResponseSuccess
  | appsAdvApiRouterGetProfileEventsResponseError;

export const getAppsAdvApiRouterGetProfileEventsUrl = (username: string) => {
  return `/api/profiles/${username}/events/`;
};

export const appsAdvApiRouterGetProfileEvents = async (
  username: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterGetProfileEventsResponse> => {
  return customFetch<appsAdvApiRouterGetProfileEventsResponse>(
    getAppsAdvApiRouterGetProfileEventsUrl(username),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Get rides created by a user (by username or ID).
 * @summary Get Profile Rides
 */
export type appsAdvApiRouterGetProfileRidesResponse200 = {
  data: RideOut[];
  status: 200;
};

export type appsAdvApiRouterGetProfileRidesResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterGetProfileRidesResponseSuccess =
  appsAdvApiRouterGetProfileRidesResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterGetProfileRidesResponseError =
  appsAdvApiRouterGetProfileRidesResponse404 & {
    headers: Headers;
  };

export type appsAdvApiRouterGetProfileRidesResponse =
  | appsAdvApiRouterGetProfileRidesResponseSuccess
  | appsAdvApiRouterGetProfileRidesResponseError;

export const getAppsAdvApiRouterGetProfileRidesUrl = (username: string) => {
  return `/api/profiles/${username}/rides/`;
};

export const appsAdvApiRouterGetProfileRides = async (
  username: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterGetProfileRidesResponse> => {
  return customFetch<appsAdvApiRouterGetProfileRidesResponse>(
    getAppsAdvApiRouterGetProfileRidesUrl(username),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * List all events.
 * @summary List Events
 */
export type appsAdvApiRouterListEventsResponse200 = {
  data: PaginatedEventResponse;
  status: 200;
};

export type appsAdvApiRouterListEventsResponseSuccess =
  appsAdvApiRouterListEventsResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterListEventsResponse =
  appsAdvApiRouterListEventsResponseSuccess;

export const getAppsAdvApiRouterListEventsUrl = () => {
  return `/api/events/`;
};

export const appsAdvApiRouterListEvents = async (
  options?: RequestInit,
): Promise<appsAdvApiRouterListEventsResponse> => {
  return customFetch<appsAdvApiRouterListEventsResponse>(
    getAppsAdvApiRouterListEventsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Create a new event.
 * @summary Create Event
 */
export type appsAdvApiRouterCreateEventResponse201 = {
  data: EventOut;
  status: 201;
};

export type appsAdvApiRouterCreateEventResponse400 = {
  data: AppsAdvApiRouterCreateEvent400;
  status: 400;
};

export type appsAdvApiRouterCreateEventResponseSuccess =
  appsAdvApiRouterCreateEventResponse201 & {
    headers: Headers;
  };
export type appsAdvApiRouterCreateEventResponseError =
  appsAdvApiRouterCreateEventResponse400 & {
    headers: Headers;
  };

export type appsAdvApiRouterCreateEventResponse =
  | appsAdvApiRouterCreateEventResponseSuccess
  | appsAdvApiRouterCreateEventResponseError;

export const getAppsAdvApiRouterCreateEventUrl = () => {
  return `/api/events/`;
};

export const appsAdvApiRouterCreateEvent = async (
  eventCreate: EventCreate,
  options?: RequestInit,
): Promise<appsAdvApiRouterCreateEventResponse> => {
  return customFetch<appsAdvApiRouterCreateEventResponse>(
    getAppsAdvApiRouterCreateEventUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(eventCreate),
    },
  );
};

/**
 * Get the first featured rally event.
 * @summary Get Featured Rally
 */
export type appsAdvApiRouterGetFeaturedRallyResponse200 = {
  data: AppsAdvApiRouterGetFeaturedRally200;
  status: 200;
};

export type appsAdvApiRouterGetFeaturedRallyResponse500 = {
  data: ErrorResponse;
  status: 500;
};

export type appsAdvApiRouterGetFeaturedRallyResponseSuccess =
  appsAdvApiRouterGetFeaturedRallyResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterGetFeaturedRallyResponseError =
  appsAdvApiRouterGetFeaturedRallyResponse500 & {
    headers: Headers;
  };

export type appsAdvApiRouterGetFeaturedRallyResponse =
  | appsAdvApiRouterGetFeaturedRallyResponseSuccess
  | appsAdvApiRouterGetFeaturedRallyResponseError;

export const getAppsAdvApiRouterGetFeaturedRallyUrl = () => {
  return `/api/events/featured-rally/`;
};

export const appsAdvApiRouterGetFeaturedRally = async (
  options?: RequestInit,
): Promise<appsAdvApiRouterGetFeaturedRallyResponse> => {
  return customFetch<appsAdvApiRouterGetFeaturedRallyResponse>(
    getAppsAdvApiRouterGetFeaturedRallyUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Get an event by ID.
 * @summary Get Event
 */
export type appsAdvApiRouterGetEventResponse200 = {
  data: EventOut;
  status: 200;
};

export type appsAdvApiRouterGetEventResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterGetEventResponseSuccess =
  appsAdvApiRouterGetEventResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterGetEventResponseError =
  appsAdvApiRouterGetEventResponse404 & {
    headers: Headers;
  };

export type appsAdvApiRouterGetEventResponse =
  | appsAdvApiRouterGetEventResponseSuccess
  | appsAdvApiRouterGetEventResponseError;

export const getAppsAdvApiRouterGetEventUrl = (eventId: string) => {
  return `/api/events/${eventId}/`;
};

export const appsAdvApiRouterGetEvent = async (
  eventId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterGetEventResponse> => {
  return customFetch<appsAdvApiRouterGetEventResponse>(
    getAppsAdvApiRouterGetEventUrl(eventId),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Update an event (partial).
 * @summary Update Event
 */
export type appsAdvApiRouterUpdateEventResponse200 = {
  data: EventOut;
  status: 200;
};

export type appsAdvApiRouterUpdateEventResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterUpdateEventResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterUpdateEventResponseSuccess =
  appsAdvApiRouterUpdateEventResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterUpdateEventResponseError = (
  | appsAdvApiRouterUpdateEventResponse403
  | appsAdvApiRouterUpdateEventResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterUpdateEventResponse =
  | appsAdvApiRouterUpdateEventResponseSuccess
  | appsAdvApiRouterUpdateEventResponseError;

export const getAppsAdvApiRouterUpdateEventUrl = (eventId: string) => {
  return `/api/events/${eventId}/`;
};

export const appsAdvApiRouterUpdateEvent = async (
  eventId: string,
  eventUpdate: EventUpdate,
  options?: RequestInit,
): Promise<appsAdvApiRouterUpdateEventResponse> => {
  return customFetch<appsAdvApiRouterUpdateEventResponse>(
    getAppsAdvApiRouterUpdateEventUrl(eventId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(eventUpdate),
    },
  );
};

/**
 * Delete an event.
 * @summary Delete Event
 */
export type appsAdvApiRouterDeleteEventResponse204 = {
  data: void;
  status: 204;
};

export type appsAdvApiRouterDeleteEventResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterDeleteEventResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterDeleteEventResponseSuccess =
  appsAdvApiRouterDeleteEventResponse204 & {
    headers: Headers;
  };
export type appsAdvApiRouterDeleteEventResponseError = (
  | appsAdvApiRouterDeleteEventResponse403
  | appsAdvApiRouterDeleteEventResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterDeleteEventResponse =
  | appsAdvApiRouterDeleteEventResponseSuccess
  | appsAdvApiRouterDeleteEventResponseError;

export const getAppsAdvApiRouterDeleteEventUrl = (eventId: string) => {
  return `/api/events/${eventId}/`;
};

export const appsAdvApiRouterDeleteEvent = async (
  eventId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterDeleteEventResponse> => {
  return customFetch<appsAdvApiRouterDeleteEventResponse>(
    getAppsAdvApiRouterDeleteEventUrl(eventId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

/**
 * Register for an event.
 * @summary Register For Event
 */
export type appsAdvApiRouterRegisterForEventResponse200 = {
  data: MessageResponse;
  status: 200;
};

export type appsAdvApiRouterRegisterForEventResponseSuccess =
  appsAdvApiRouterRegisterForEventResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterRegisterForEventResponse =
  appsAdvApiRouterRegisterForEventResponseSuccess;

export const getAppsAdvApiRouterRegisterForEventUrl = (eventId: string) => {
  return `/api/events/${eventId}/register/`;
};

export const appsAdvApiRouterRegisterForEvent = async (
  eventId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterRegisterForEventResponse> => {
  return customFetch<appsAdvApiRouterRegisterForEventResponse>(
    getAppsAdvApiRouterRegisterForEventUrl(eventId),
    {
      ...options,
      method: "POST",
    },
  );
};

/**
 * List rides with optional filters.
 * @summary List Rides
 */
export type appsAdvApiRouterListRidesResponse200 = {
  data: PaginatedRideResponse;
  status: 200;
};

export type appsAdvApiRouterListRidesResponseSuccess =
  appsAdvApiRouterListRidesResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterListRidesResponse =
  appsAdvApiRouterListRidesResponseSuccess;

export const getAppsAdvApiRouterListRidesUrl = (
  params?: AppsAdvApiRouterListRidesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/rides/?${stringifiedParams}`
    : `/api/rides/`;
};

export const appsAdvApiRouterListRides = async (
  params?: AppsAdvApiRouterListRidesParams,
  options?: RequestInit,
): Promise<appsAdvApiRouterListRidesResponse> => {
  return customFetch<appsAdvApiRouterListRidesResponse>(
    getAppsAdvApiRouterListRidesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Create a new ride.
 * @summary Create Ride
 */
export type appsAdvApiRouterCreateRideResponse201 = {
  data: RideOut;
  status: 201;
};

export type appsAdvApiRouterCreateRideResponse400 = {
  data: AppsAdvApiRouterCreateRide400;
  status: 400;
};

export type appsAdvApiRouterCreateRideResponseSuccess =
  appsAdvApiRouterCreateRideResponse201 & {
    headers: Headers;
  };
export type appsAdvApiRouterCreateRideResponseError =
  appsAdvApiRouterCreateRideResponse400 & {
    headers: Headers;
  };

export type appsAdvApiRouterCreateRideResponse =
  | appsAdvApiRouterCreateRideResponseSuccess
  | appsAdvApiRouterCreateRideResponseError;

export const getAppsAdvApiRouterCreateRideUrl = () => {
  return `/api/rides/`;
};

export const appsAdvApiRouterCreateRide = async (
  rideCreate: RideCreate,
  options?: RequestInit,
): Promise<appsAdvApiRouterCreateRideResponse> => {
  return customFetch<appsAdvApiRouterCreateRideResponse>(
    getAppsAdvApiRouterCreateRideUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(rideCreate),
    },
  );
};

/**
 * Get all RSVPs for the authenticated user.
 * @summary Get My Rsvps
 */
export type appsAdvApiRouterGetMyRsvpsResponse200 = {
  data: PaginatedRSVPResponse;
  status: 200;
};

export type appsAdvApiRouterGetMyRsvpsResponseSuccess =
  appsAdvApiRouterGetMyRsvpsResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterGetMyRsvpsResponse =
  appsAdvApiRouterGetMyRsvpsResponseSuccess;

export const getAppsAdvApiRouterGetMyRsvpsUrl = () => {
  return `/api/rides/my-rsvps/`;
};

export const appsAdvApiRouterGetMyRsvps = async (
  options?: RequestInit,
): Promise<appsAdvApiRouterGetMyRsvpsResponse> => {
  return customFetch<appsAdvApiRouterGetMyRsvpsResponse>(
    getAppsAdvApiRouterGetMyRsvpsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Get RSVP lists for all rides created by the authenticated user.
 * @summary Get My Rides Rsvps
 */
export type appsAdvApiRouterGetMyRidesRsvpsResponse200 = {
  data: PaginatedMyRidesRSVPsResponse;
  status: 200;
};

export type appsAdvApiRouterGetMyRidesRsvpsResponseSuccess =
  appsAdvApiRouterGetMyRidesRsvpsResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterGetMyRidesRsvpsResponse =
  appsAdvApiRouterGetMyRidesRsvpsResponseSuccess;

export const getAppsAdvApiRouterGetMyRidesRsvpsUrl = () => {
  return `/api/rides/my-rides-rsvps/`;
};

export const appsAdvApiRouterGetMyRidesRsvps = async (
  options?: RequestInit,
): Promise<appsAdvApiRouterGetMyRidesRsvpsResponse> => {
  return customFetch<appsAdvApiRouterGetMyRidesRsvpsResponse>(
    getAppsAdvApiRouterGetMyRidesRsvpsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Upload a ride image.
 * @summary Upload Image
 */
export type appsAdvApiRouterUploadImageResponse200 = {
  data: ImageUploadResponse;
  status: 200;
};

export type appsAdvApiRouterUploadImageResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsAdvApiRouterUploadImageResponse500 = {
  data: ErrorResponse;
  status: 500;
};

export type appsAdvApiRouterUploadImageResponseSuccess =
  appsAdvApiRouterUploadImageResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterUploadImageResponseError = (
  | appsAdvApiRouterUploadImageResponse400
  | appsAdvApiRouterUploadImageResponse500
) & {
  headers: Headers;
};

export type appsAdvApiRouterUploadImageResponse =
  | appsAdvApiRouterUploadImageResponseSuccess
  | appsAdvApiRouterUploadImageResponseError;

export const getAppsAdvApiRouterUploadImageUrl = () => {
  return `/api/rides/upload-image/`;
};

export const appsAdvApiRouterUploadImage = async (
  appsAdvApiRouterUploadImageBody: AppsAdvApiRouterUploadImageBody,
  options?: RequestInit,
): Promise<appsAdvApiRouterUploadImageResponse> => {
  const formData = new FormData();
  formData.append(`image`, appsAdvApiRouterUploadImageBody.image);

  return customFetch<appsAdvApiRouterUploadImageResponse>(
    getAppsAdvApiRouterUploadImageUrl(),
    {
      ...options,
      method: "POST",
      body: formData,
    },
  );
};

/**
 * Handle RSVP approval via email link. Returns HTML template.
 * @summary Approve Rsvp
 */
export type appsAdvApiRouterApproveRsvpResponse200 = {
  data: void;
  status: 200;
};

export type appsAdvApiRouterApproveRsvpResponseSuccess =
  appsAdvApiRouterApproveRsvpResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterApproveRsvpResponse =
  appsAdvApiRouterApproveRsvpResponseSuccess;

export const getAppsAdvApiRouterApproveRsvpUrl = (token: string) => {
  return `/api/rides/approve-rsvp/${token}/`;
};

export const appsAdvApiRouterApproveRsvp = async (
  token: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterApproveRsvpResponse> => {
  return customFetch<appsAdvApiRouterApproveRsvpResponse>(
    getAppsAdvApiRouterApproveRsvpUrl(token),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Get a ride by ID.
 * @summary Get Ride
 */
export type appsAdvApiRouterGetRideResponse200 = {
  data: RideOut;
  status: 200;
};

export type appsAdvApiRouterGetRideResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterGetRideResponseSuccess =
  appsAdvApiRouterGetRideResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterGetRideResponseError =
  appsAdvApiRouterGetRideResponse404 & {
    headers: Headers;
  };

export type appsAdvApiRouterGetRideResponse =
  | appsAdvApiRouterGetRideResponseSuccess
  | appsAdvApiRouterGetRideResponseError;

export const getAppsAdvApiRouterGetRideUrl = (rideId: string) => {
  return `/api/rides/${rideId}/`;
};

export const appsAdvApiRouterGetRide = async (
  rideId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterGetRideResponse> => {
  return customFetch<appsAdvApiRouterGetRideResponse>(
    getAppsAdvApiRouterGetRideUrl(rideId),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Update a ride (partial).
 * @summary Update Ride
 */
export type appsAdvApiRouterUpdateRideResponse200 = {
  data: RideOut;
  status: 200;
};

export type appsAdvApiRouterUpdateRideResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsAdvApiRouterUpdateRideResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterUpdateRideResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterUpdateRideResponseSuccess =
  appsAdvApiRouterUpdateRideResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterUpdateRideResponseError = (
  | appsAdvApiRouterUpdateRideResponse400
  | appsAdvApiRouterUpdateRideResponse403
  | appsAdvApiRouterUpdateRideResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterUpdateRideResponse =
  | appsAdvApiRouterUpdateRideResponseSuccess
  | appsAdvApiRouterUpdateRideResponseError;

export const getAppsAdvApiRouterUpdateRideUrl = (rideId: string) => {
  return `/api/rides/${rideId}/`;
};

export const appsAdvApiRouterUpdateRide = async (
  rideId: string,
  rideUpdate: RideUpdate,
  options?: RequestInit,
): Promise<appsAdvApiRouterUpdateRideResponse> => {
  return customFetch<appsAdvApiRouterUpdateRideResponse>(
    getAppsAdvApiRouterUpdateRideUrl(rideId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(rideUpdate),
    },
  );
};

/**
 * Delete a ride.
 * @summary Delete Ride
 */
export type appsAdvApiRouterDeleteRideResponse204 = {
  data: void;
  status: 204;
};

export type appsAdvApiRouterDeleteRideResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterDeleteRideResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterDeleteRideResponseSuccess =
  appsAdvApiRouterDeleteRideResponse204 & {
    headers: Headers;
  };
export type appsAdvApiRouterDeleteRideResponseError = (
  | appsAdvApiRouterDeleteRideResponse403
  | appsAdvApiRouterDeleteRideResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterDeleteRideResponse =
  | appsAdvApiRouterDeleteRideResponseSuccess
  | appsAdvApiRouterDeleteRideResponseError;

export const getAppsAdvApiRouterDeleteRideUrl = (rideId: string) => {
  return `/api/rides/${rideId}/`;
};

export const appsAdvApiRouterDeleteRide = async (
  rideId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterDeleteRideResponse> => {
  return customFetch<appsAdvApiRouterDeleteRideResponse>(
    getAppsAdvApiRouterDeleteRideUrl(rideId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

/**
 * RSVP to a ride.
 * @summary Rsvp To Ride
 */
export type appsAdvApiRouterRsvpToRideResponse200 = {
  data: MessageResponse;
  status: 200;
};

export type appsAdvApiRouterRsvpToRideResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsAdvApiRouterRsvpToRideResponseSuccess =
  appsAdvApiRouterRsvpToRideResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterRsvpToRideResponseError =
  appsAdvApiRouterRsvpToRideResponse400 & {
    headers: Headers;
  };

export type appsAdvApiRouterRsvpToRideResponse =
  | appsAdvApiRouterRsvpToRideResponseSuccess
  | appsAdvApiRouterRsvpToRideResponseError;

export const getAppsAdvApiRouterRsvpToRideUrl = (rideId: string) => {
  return `/api/rides/${rideId}/rsvp/`;
};

export const appsAdvApiRouterRsvpToRide = async (
  rideId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterRsvpToRideResponse> => {
  return customFetch<appsAdvApiRouterRsvpToRideResponse>(
    getAppsAdvApiRouterRsvpToRideUrl(rideId),
    {
      ...options,
      method: "POST",
    },
  );
};

/**
 * Remove RSVP from a ride.
 * @summary Unrsvp From Ride
 */
export type appsAdvApiRouterUnrsvpFromRideResponse200 = {
  data: MessageResponse;
  status: 200;
};

export type appsAdvApiRouterUnrsvpFromRideResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsAdvApiRouterUnrsvpFromRideResponseSuccess =
  appsAdvApiRouterUnrsvpFromRideResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterUnrsvpFromRideResponseError =
  appsAdvApiRouterUnrsvpFromRideResponse400 & {
    headers: Headers;
  };

export type appsAdvApiRouterUnrsvpFromRideResponse =
  | appsAdvApiRouterUnrsvpFromRideResponseSuccess
  | appsAdvApiRouterUnrsvpFromRideResponseError;

export const getAppsAdvApiRouterUnrsvpFromRideUrl = (rideId: string) => {
  return `/api/rides/${rideId}/unrsvp/`;
};

export const appsAdvApiRouterUnrsvpFromRide = async (
  rideId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterUnrsvpFromRideResponse> => {
  return customFetch<appsAdvApiRouterUnrsvpFromRideResponse>(
    getAppsAdvApiRouterUnrsvpFromRideUrl(rideId),
    {
      ...options,
      method: "POST",
    },
  );
};

/**
 * Get RSVP status for the authenticated user for a specific ride.
 * @summary Get Rsvp Status
 */
export type appsAdvApiRouterGetRsvpStatusResponse200 = {
  data: RSVPStatusResponse;
  status: 200;
};

export type appsAdvApiRouterGetRsvpStatusResponseSuccess =
  appsAdvApiRouterGetRsvpStatusResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterGetRsvpStatusResponse =
  appsAdvApiRouterGetRsvpStatusResponseSuccess;

export const getAppsAdvApiRouterGetRsvpStatusUrl = (rideId: string) => {
  return `/api/rides/${rideId}/rsvp-status/`;
};

export const appsAdvApiRouterGetRsvpStatus = async (
  rideId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterGetRsvpStatusResponse> => {
  return customFetch<appsAdvApiRouterGetRsvpStatusResponse>(
    getAppsAdvApiRouterGetRsvpStatusUrl(rideId),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Get list of users who have RSVPed to a specific ride (ride owner only).
 * @summary Get Rsvp List
 */
export type appsAdvApiRouterGetRsvpListResponse200 = {
  data: RSVPListResponse;
  status: 200;
};

export type appsAdvApiRouterGetRsvpListResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterGetRsvpListResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterGetRsvpListResponseSuccess =
  appsAdvApiRouterGetRsvpListResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterGetRsvpListResponseError = (
  | appsAdvApiRouterGetRsvpListResponse403
  | appsAdvApiRouterGetRsvpListResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterGetRsvpListResponse =
  | appsAdvApiRouterGetRsvpListResponseSuccess
  | appsAdvApiRouterGetRsvpListResponseError;

export const getAppsAdvApiRouterGetRsvpListUrl = (rideId: string) => {
  return `/api/rides/${rideId}/rsvp-list/`;
};

export const appsAdvApiRouterGetRsvpList = async (
  rideId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterGetRsvpListResponse> => {
  return customFetch<appsAdvApiRouterGetRsvpListResponse>(
    getAppsAdvApiRouterGetRsvpListUrl(rideId),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Rate a ride with thumbs up or thumbs down.
 * @summary Rate Ride
 */
export type appsAdvApiRouterRateRideResponse201 = {
  data: RateRideResponse;
  status: 201;
};

export type appsAdvApiRouterRateRideResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsAdvApiRouterRateRideResponseSuccess =
  appsAdvApiRouterRateRideResponse201 & {
    headers: Headers;
  };
export type appsAdvApiRouterRateRideResponseError =
  appsAdvApiRouterRateRideResponse400 & {
    headers: Headers;
  };

export type appsAdvApiRouterRateRideResponse =
  | appsAdvApiRouterRateRideResponseSuccess
  | appsAdvApiRouterRateRideResponseError;

export const getAppsAdvApiRouterRateRideUrl = (rideId: string) => {
  return `/api/rides/${rideId}/rate/`;
};

export const appsAdvApiRouterRateRide = async (
  rideId: string,
  rateRideIn: RateRideIn,
  options?: RequestInit,
): Promise<appsAdvApiRouterRateRideResponse> => {
  return customFetch<appsAdvApiRouterRateRideResponse>(
    getAppsAdvApiRouterRateRideUrl(rideId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(rateRideIn),
    },
  );
};

/**
 * Get presigned S3 URL for GPX upload. Ride creator only.
 * @summary Get Track Upload Url
 */
export type appsAdvApiRouterGetTrackUploadUrlResponse200 = {
  data: TrackUploadUrlResponse;
  status: 200;
};

export type appsAdvApiRouterGetTrackUploadUrlResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterGetTrackUploadUrlResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterGetTrackUploadUrlResponseSuccess =
  appsAdvApiRouterGetTrackUploadUrlResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterGetTrackUploadUrlResponseError = (
  | appsAdvApiRouterGetTrackUploadUrlResponse403
  | appsAdvApiRouterGetTrackUploadUrlResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterGetTrackUploadUrlResponse =
  | appsAdvApiRouterGetTrackUploadUrlResponseSuccess
  | appsAdvApiRouterGetTrackUploadUrlResponseError;

export const getAppsAdvApiRouterGetTrackUploadUrlUrl = (rideId: string) => {
  return `/api/rides/${rideId}/track/upload-url/`;
};

export const appsAdvApiRouterGetTrackUploadUrl = async (
  rideId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterGetTrackUploadUrlResponse> => {
  return customFetch<appsAdvApiRouterGetTrackUploadUrlResponse>(
    getAppsAdvApiRouterGetTrackUploadUrlUrl(rideId),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Trigger processing after S3 upload. Creates RideTrack record.
 * @summary Process Track
 */
export type appsAdvApiRouterProcessTrackResponse200 = {
  data: TrackResponse;
  status: 200;
};

export type appsAdvApiRouterProcessTrackResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsAdvApiRouterProcessTrackResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterProcessTrackResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterProcessTrackResponseSuccess =
  appsAdvApiRouterProcessTrackResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterProcessTrackResponseError = (
  | appsAdvApiRouterProcessTrackResponse400
  | appsAdvApiRouterProcessTrackResponse403
  | appsAdvApiRouterProcessTrackResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterProcessTrackResponse =
  | appsAdvApiRouterProcessTrackResponseSuccess
  | appsAdvApiRouterProcessTrackResponseError;

export const getAppsAdvApiRouterProcessTrackUrl = (rideId: string) => {
  return `/api/rides/${rideId}/track/process/`;
};

export const appsAdvApiRouterProcessTrack = async (
  rideId: string,
  trackProcessRequest: TrackProcessRequest,
  options?: RequestInit,
): Promise<appsAdvApiRouterProcessTrackResponse> => {
  return customFetch<appsAdvApiRouterProcessTrackResponse>(
    getAppsAdvApiRouterProcessTrackUrl(rideId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(trackProcessRequest),
    },
  );
};

/**
 * Get track GeoJSON and metadata.
 * @summary Get Track
 */
export type appsAdvApiRouterGetTrackResponse200 = {
  data: TrackResponse;
  status: 200;
};

export type appsAdvApiRouterGetTrackResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterGetTrackResponseSuccess =
  appsAdvApiRouterGetTrackResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterGetTrackResponseError =
  appsAdvApiRouterGetTrackResponse404 & {
    headers: Headers;
  };

export type appsAdvApiRouterGetTrackResponse =
  | appsAdvApiRouterGetTrackResponseSuccess
  | appsAdvApiRouterGetTrackResponseError;

export const getAppsAdvApiRouterGetTrackUrl = (rideId: string) => {
  return `/api/rides/${rideId}/track/`;
};

export const appsAdvApiRouterGetTrack = async (
  rideId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterGetTrackResponse> => {
  return customFetch<appsAdvApiRouterGetTrackResponse>(
    getAppsAdvApiRouterGetTrackUrl(rideId),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Update track settings (allow_download). Ride creator only.
 * @summary Update Track
 */
export type appsAdvApiRouterUpdateTrackResponse200 = {
  data: TrackResponse;
  status: 200;
};

export type appsAdvApiRouterUpdateTrackResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterUpdateTrackResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterUpdateTrackResponseSuccess =
  appsAdvApiRouterUpdateTrackResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterUpdateTrackResponseError = (
  | appsAdvApiRouterUpdateTrackResponse403
  | appsAdvApiRouterUpdateTrackResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterUpdateTrackResponse =
  | appsAdvApiRouterUpdateTrackResponseSuccess
  | appsAdvApiRouterUpdateTrackResponseError;

export const getAppsAdvApiRouterUpdateTrackUrl = (rideId: string) => {
  return `/api/rides/${rideId}/track/`;
};

export const appsAdvApiRouterUpdateTrack = async (
  rideId: string,
  trackUpdateRequest: TrackUpdateRequest,
  options?: RequestInit,
): Promise<appsAdvApiRouterUpdateTrackResponse> => {
  return customFetch<appsAdvApiRouterUpdateTrackResponse>(
    getAppsAdvApiRouterUpdateTrackUrl(rideId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(trackUpdateRequest),
    },
  );
};

/**
 * Delete track. Ride creator only.
 * @summary Delete Track
 */
export type appsAdvApiRouterDeleteTrackResponse200 = {
  data: MessageResponse;
  status: 200;
};

export type appsAdvApiRouterDeleteTrackResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterDeleteTrackResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterDeleteTrackResponseSuccess =
  appsAdvApiRouterDeleteTrackResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterDeleteTrackResponseError = (
  | appsAdvApiRouterDeleteTrackResponse403
  | appsAdvApiRouterDeleteTrackResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterDeleteTrackResponse =
  | appsAdvApiRouterDeleteTrackResponseSuccess
  | appsAdvApiRouterDeleteTrackResponseError;

export const getAppsAdvApiRouterDeleteTrackUrl = (rideId: string) => {
  return `/api/rides/${rideId}/track/`;
};

export const appsAdvApiRouterDeleteTrack = async (
  rideId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterDeleteTrackResponse> => {
  return customFetch<appsAdvApiRouterDeleteTrackResponse>(
    getAppsAdvApiRouterDeleteTrackUrl(rideId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

/**
 * Get presigned download URL. RSVP'd users only.
 * @summary Get Track Download Url
 */
export type appsAdvApiRouterGetTrackDownloadUrlResponse200 = {
  data: TrackDownloadResponse;
  status: 200;
};

export type appsAdvApiRouterGetTrackDownloadUrlResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterGetTrackDownloadUrlResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterGetTrackDownloadUrlResponseSuccess =
  appsAdvApiRouterGetTrackDownloadUrlResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterGetTrackDownloadUrlResponseError = (
  | appsAdvApiRouterGetTrackDownloadUrlResponse403
  | appsAdvApiRouterGetTrackDownloadUrlResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterGetTrackDownloadUrlResponse =
  | appsAdvApiRouterGetTrackDownloadUrlResponseSuccess
  | appsAdvApiRouterGetTrackDownloadUrlResponseError;

export const getAppsAdvApiRouterGetTrackDownloadUrlUrl = (rideId: string) => {
  return `/api/rides/${rideId}/track/download/`;
};

export const appsAdvApiRouterGetTrackDownloadUrl = async (
  rideId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterGetTrackDownloadUrlResponse> => {
  return customFetch<appsAdvApiRouterGetTrackDownloadUrlResponse>(
    getAppsAdvApiRouterGetTrackDownloadUrlUrl(rideId),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Join the waitlist for a ride.
Rate limited to 1 request per minute per user per ride.
Only allowed if ride is full and user is not already RSVP'd or on waitlist.
 * @summary Join Waitlist
 */
export type appsAdvApiRouterJoinWaitlistResponse200 = {
  data: WaitlistStatusResponse;
  status: 200;
};

export type appsAdvApiRouterJoinWaitlistResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsAdvApiRouterJoinWaitlistResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterJoinWaitlistResponse429 = {
  data: ErrorResponse;
  status: 429;
};

export type appsAdvApiRouterJoinWaitlistResponseSuccess =
  appsAdvApiRouterJoinWaitlistResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterJoinWaitlistResponseError = (
  | appsAdvApiRouterJoinWaitlistResponse400
  | appsAdvApiRouterJoinWaitlistResponse404
  | appsAdvApiRouterJoinWaitlistResponse429
) & {
  headers: Headers;
};

export type appsAdvApiRouterJoinWaitlistResponse =
  | appsAdvApiRouterJoinWaitlistResponseSuccess
  | appsAdvApiRouterJoinWaitlistResponseError;

export const getAppsAdvApiRouterJoinWaitlistUrl = (rideId: string) => {
  return `/api/rides/${rideId}/waitlist/join/`;
};

export const appsAdvApiRouterJoinWaitlist = async (
  rideId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterJoinWaitlistResponse> => {
  return customFetch<appsAdvApiRouterJoinWaitlistResponse>(
    getAppsAdvApiRouterJoinWaitlistUrl(rideId),
    {
      ...options,
      method: "POST",
    },
  );
};

/**
 * Leave the waitlist for a ride.
 * @summary Leave Waitlist
 */
export type appsAdvApiRouterLeaveWaitlistResponse200 = {
  data: MessageResponse;
  status: 200;
};

export type appsAdvApiRouterLeaveWaitlistResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsAdvApiRouterLeaveWaitlistResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterLeaveWaitlistResponseSuccess =
  appsAdvApiRouterLeaveWaitlistResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterLeaveWaitlistResponseError = (
  | appsAdvApiRouterLeaveWaitlistResponse400
  | appsAdvApiRouterLeaveWaitlistResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterLeaveWaitlistResponse =
  | appsAdvApiRouterLeaveWaitlistResponseSuccess
  | appsAdvApiRouterLeaveWaitlistResponseError;

export const getAppsAdvApiRouterLeaveWaitlistUrl = (rideId: string) => {
  return `/api/rides/${rideId}/waitlist/leave/`;
};

export const appsAdvApiRouterLeaveWaitlist = async (
  rideId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterLeaveWaitlistResponse> => {
  return customFetch<appsAdvApiRouterLeaveWaitlistResponse>(
    getAppsAdvApiRouterLeaveWaitlistUrl(rideId),
    {
      ...options,
      method: "POST",
    },
  );
};

/**
 * Get user's position on the waitlist for a ride.
 * @summary Get Waitlist Position
 */
export type appsAdvApiRouterGetWaitlistPositionResponse200 = {
  data: WaitlistStatusResponse;
  status: 200;
};

export type appsAdvApiRouterGetWaitlistPositionResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterGetWaitlistPositionResponseSuccess =
  appsAdvApiRouterGetWaitlistPositionResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterGetWaitlistPositionResponseError =
  appsAdvApiRouterGetWaitlistPositionResponse404 & {
    headers: Headers;
  };

export type appsAdvApiRouterGetWaitlistPositionResponse =
  | appsAdvApiRouterGetWaitlistPositionResponseSuccess
  | appsAdvApiRouterGetWaitlistPositionResponseError;

export const getAppsAdvApiRouterGetWaitlistPositionUrl = (rideId: string) => {
  return `/api/rides/${rideId}/waitlist/position/`;
};

export const appsAdvApiRouterGetWaitlistPosition = async (
  rideId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterGetWaitlistPositionResponse> => {
  return customFetch<appsAdvApiRouterGetWaitlistPositionResponse>(
    getAppsAdvApiRouterGetWaitlistPositionUrl(rideId),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Get list of users on the waitlist for a ride.
Only the ride organizer can view the waitlist.
 * @summary List Waitlist
 */
export type appsAdvApiRouterListWaitlistResponse200 = {
  data: WaitlistListResponse;
  status: 200;
};

export type appsAdvApiRouterListWaitlistResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterListWaitlistResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterListWaitlistResponseSuccess =
  appsAdvApiRouterListWaitlistResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterListWaitlistResponseError = (
  | appsAdvApiRouterListWaitlistResponse403
  | appsAdvApiRouterListWaitlistResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterListWaitlistResponse =
  | appsAdvApiRouterListWaitlistResponseSuccess
  | appsAdvApiRouterListWaitlistResponseError;

export const getAppsAdvApiRouterListWaitlistUrl = (rideId: string) => {
  return `/api/rides/${rideId}/waitlist/`;
};

export const appsAdvApiRouterListWaitlist = async (
  rideId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterListWaitlistResponse> => {
  return customFetch<appsAdvApiRouterListWaitlistResponse>(
    getAppsAdvApiRouterListWaitlistUrl(rideId),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Remove a user from the waitlist.
Only the ride organizer can remove users from the waitlist.
 * @summary Remove From Waitlist
 */
export type appsAdvApiRouterRemoveFromWaitlistResponse200 = {
  data: MessageResponse;
  status: 200;
};

export type appsAdvApiRouterRemoveFromWaitlistResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterRemoveFromWaitlistResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterRemoveFromWaitlistResponseSuccess =
  appsAdvApiRouterRemoveFromWaitlistResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterRemoveFromWaitlistResponseError = (
  | appsAdvApiRouterRemoveFromWaitlistResponse403
  | appsAdvApiRouterRemoveFromWaitlistResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterRemoveFromWaitlistResponse =
  | appsAdvApiRouterRemoveFromWaitlistResponseSuccess
  | appsAdvApiRouterRemoveFromWaitlistResponseError;

export const getAppsAdvApiRouterRemoveFromWaitlistUrl = (
  rideId: string,
  entryId: string,
) => {
  return `/api/rides/${rideId}/waitlist/${entryId}/`;
};

export const appsAdvApiRouterRemoveFromWaitlist = async (
  rideId: string,
  entryId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterRemoveFromWaitlistResponse> => {
  return customFetch<appsAdvApiRouterRemoveFromWaitlistResponse>(
    getAppsAdvApiRouterRemoveFromWaitlistUrl(rideId, entryId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

/**
 * Get list of pending approval requests for a ride.
Only the ride organizer can view approval requests.
 * @summary List Approval Requests
 */
export type appsAdvApiRouterListApprovalRequestsResponse200 = {
  data: ApprovalListResponse;
  status: 200;
};

export type appsAdvApiRouterListApprovalRequestsResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterListApprovalRequestsResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterListApprovalRequestsResponseSuccess =
  appsAdvApiRouterListApprovalRequestsResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterListApprovalRequestsResponseError = (
  | appsAdvApiRouterListApprovalRequestsResponse403
  | appsAdvApiRouterListApprovalRequestsResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterListApprovalRequestsResponse =
  | appsAdvApiRouterListApprovalRequestsResponseSuccess
  | appsAdvApiRouterListApprovalRequestsResponseError;

export const getAppsAdvApiRouterListApprovalRequestsUrl = (rideId: string) => {
  return `/api/rides/${rideId}/approvals/`;
};

export const appsAdvApiRouterListApprovalRequests = async (
  rideId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterListApprovalRequestsResponse> => {
  return customFetch<appsAdvApiRouterListApprovalRequestsResponse>(
    getAppsAdvApiRouterListApprovalRequestsUrl(rideId),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Approve a pending RSVP request.
Only the ride organizer can approve requests.
If the ride is full, the user is added to the waitlist instead.
 * @summary Approve Approval Request
 */
export type appsAdvApiRouterApproveApprovalRequestResponse200 = {
  data: MessageResponse;
  status: 200;
};

export type appsAdvApiRouterApproveApprovalRequestResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsAdvApiRouterApproveApprovalRequestResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterApproveApprovalRequestResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterApproveApprovalRequestResponseSuccess =
  appsAdvApiRouterApproveApprovalRequestResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterApproveApprovalRequestResponseError = (
  | appsAdvApiRouterApproveApprovalRequestResponse400
  | appsAdvApiRouterApproveApprovalRequestResponse403
  | appsAdvApiRouterApproveApprovalRequestResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterApproveApprovalRequestResponse =
  | appsAdvApiRouterApproveApprovalRequestResponseSuccess
  | appsAdvApiRouterApproveApprovalRequestResponseError;

export const getAppsAdvApiRouterApproveApprovalRequestUrl = (
  rideId: string,
  requestId: string,
) => {
  return `/api/rides/${rideId}/approvals/${requestId}/approve/`;
};

export const appsAdvApiRouterApproveApprovalRequest = async (
  rideId: string,
  requestId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterApproveApprovalRequestResponse> => {
  return customFetch<appsAdvApiRouterApproveApprovalRequestResponse>(
    getAppsAdvApiRouterApproveApprovalRequestUrl(rideId, requestId),
    {
      ...options,
      method: "POST",
    },
  );
};

/**
 * Decline a pending RSVP request.
Only the ride organizer can decline requests.
 * @summary Decline Approval Request
 */
export type appsAdvApiRouterDeclineApprovalRequestResponse200 = {
  data: MessageResponse;
  status: 200;
};

export type appsAdvApiRouterDeclineApprovalRequestResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterDeclineApprovalRequestResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterDeclineApprovalRequestResponseSuccess =
  appsAdvApiRouterDeclineApprovalRequestResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterDeclineApprovalRequestResponseError = (
  | appsAdvApiRouterDeclineApprovalRequestResponse403
  | appsAdvApiRouterDeclineApprovalRequestResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterDeclineApprovalRequestResponse =
  | appsAdvApiRouterDeclineApprovalRequestResponseSuccess
  | appsAdvApiRouterDeclineApprovalRequestResponseError;

export const getAppsAdvApiRouterDeclineApprovalRequestUrl = (
  rideId: string,
  requestId: string,
) => {
  return `/api/rides/${rideId}/approvals/${requestId}/decline/`;
};

export const appsAdvApiRouterDeclineApprovalRequest = async (
  rideId: string,
  requestId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterDeclineApprovalRequestResponse> => {
  return customFetch<appsAdvApiRouterDeclineApprovalRequestResponse>(
    getAppsAdvApiRouterDeclineApprovalRequestUrl(rideId, requestId),
    {
      ...options,
      method: "POST",
    },
  );
};

/**
 * List all featured content.
 * @summary List Featured Content
 */
export type appsAdvApiRouterListFeaturedContentResponse200 = {
  data: FeaturedContentOut[];
  status: 200;
};

export type appsAdvApiRouterListFeaturedContentResponseSuccess =
  appsAdvApiRouterListFeaturedContentResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterListFeaturedContentResponse =
  appsAdvApiRouterListFeaturedContentResponseSuccess;

export const getAppsAdvApiRouterListFeaturedContentUrl = () => {
  return `/api/featured-content/`;
};

export const appsAdvApiRouterListFeaturedContent = async (
  options?: RequestInit,
): Promise<appsAdvApiRouterListFeaturedContentResponse> => {
  return customFetch<appsAdvApiRouterListFeaturedContentResponse>(
    getAppsAdvApiRouterListFeaturedContentUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Create new featured content (admin only).
 * @summary Create Featured Content
 */
export type appsAdvApiRouterCreateFeaturedContentResponse201 = {
  data: FeaturedContentOut;
  status: 201;
};

export type appsAdvApiRouterCreateFeaturedContentResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterCreateFeaturedContentResponseSuccess =
  appsAdvApiRouterCreateFeaturedContentResponse201 & {
    headers: Headers;
  };
export type appsAdvApiRouterCreateFeaturedContentResponseError =
  appsAdvApiRouterCreateFeaturedContentResponse403 & {
    headers: Headers;
  };

export type appsAdvApiRouterCreateFeaturedContentResponse =
  | appsAdvApiRouterCreateFeaturedContentResponseSuccess
  | appsAdvApiRouterCreateFeaturedContentResponseError;

export const getAppsAdvApiRouterCreateFeaturedContentUrl = () => {
  return `/api/featured-content/`;
};

export const appsAdvApiRouterCreateFeaturedContent = async (
  featuredContentCreate: FeaturedContentCreate,
  options?: RequestInit,
): Promise<appsAdvApiRouterCreateFeaturedContentResponse> => {
  return customFetch<appsAdvApiRouterCreateFeaturedContentResponse>(
    getAppsAdvApiRouterCreateFeaturedContentUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(featuredContentCreate),
    },
  );
};

/**
 * Get featured content by ID.
 * @summary Get Featured Content
 */
export type appsAdvApiRouterGetFeaturedContentResponse200 = {
  data: FeaturedContentOut;
  status: 200;
};

export type appsAdvApiRouterGetFeaturedContentResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterGetFeaturedContentResponseSuccess =
  appsAdvApiRouterGetFeaturedContentResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterGetFeaturedContentResponseError =
  appsAdvApiRouterGetFeaturedContentResponse404 & {
    headers: Headers;
  };

export type appsAdvApiRouterGetFeaturedContentResponse =
  | appsAdvApiRouterGetFeaturedContentResponseSuccess
  | appsAdvApiRouterGetFeaturedContentResponseError;

export const getAppsAdvApiRouterGetFeaturedContentUrl = (contentId: string) => {
  return `/api/featured-content/${contentId}/`;
};

export const appsAdvApiRouterGetFeaturedContent = async (
  contentId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterGetFeaturedContentResponse> => {
  return customFetch<appsAdvApiRouterGetFeaturedContentResponse>(
    getAppsAdvApiRouterGetFeaturedContentUrl(contentId),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Update featured content (admin only).
 * @summary Update Featured Content
 */
export type appsAdvApiRouterUpdateFeaturedContentResponse200 = {
  data: FeaturedContentOut;
  status: 200;
};

export type appsAdvApiRouterUpdateFeaturedContentResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterUpdateFeaturedContentResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterUpdateFeaturedContentResponseSuccess =
  appsAdvApiRouterUpdateFeaturedContentResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterUpdateFeaturedContentResponseError = (
  | appsAdvApiRouterUpdateFeaturedContentResponse403
  | appsAdvApiRouterUpdateFeaturedContentResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterUpdateFeaturedContentResponse =
  | appsAdvApiRouterUpdateFeaturedContentResponseSuccess
  | appsAdvApiRouterUpdateFeaturedContentResponseError;

export const getAppsAdvApiRouterUpdateFeaturedContentUrl = (
  contentId: string,
) => {
  return `/api/featured-content/${contentId}/`;
};

export const appsAdvApiRouterUpdateFeaturedContent = async (
  contentId: string,
  featuredContentUpdate: FeaturedContentUpdate,
  options?: RequestInit,
): Promise<appsAdvApiRouterUpdateFeaturedContentResponse> => {
  return customFetch<appsAdvApiRouterUpdateFeaturedContentResponse>(
    getAppsAdvApiRouterUpdateFeaturedContentUrl(contentId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(featuredContentUpdate),
    },
  );
};

/**
 * Delete featured content (admin only).
 * @summary Delete Featured Content
 */
export type appsAdvApiRouterDeleteFeaturedContentResponse204 = {
  data: void;
  status: 204;
};

export type appsAdvApiRouterDeleteFeaturedContentResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterDeleteFeaturedContentResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsAdvApiRouterDeleteFeaturedContentResponseSuccess =
  appsAdvApiRouterDeleteFeaturedContentResponse204 & {
    headers: Headers;
  };
export type appsAdvApiRouterDeleteFeaturedContentResponseError = (
  | appsAdvApiRouterDeleteFeaturedContentResponse403
  | appsAdvApiRouterDeleteFeaturedContentResponse404
) & {
  headers: Headers;
};

export type appsAdvApiRouterDeleteFeaturedContentResponse =
  | appsAdvApiRouterDeleteFeaturedContentResponseSuccess
  | appsAdvApiRouterDeleteFeaturedContentResponseError;

export const getAppsAdvApiRouterDeleteFeaturedContentUrl = (
  contentId: string,
) => {
  return `/api/featured-content/${contentId}/`;
};

export const appsAdvApiRouterDeleteFeaturedContent = async (
  contentId: string,
  options?: RequestInit,
): Promise<appsAdvApiRouterDeleteFeaturedContentResponse> => {
  return customFetch<appsAdvApiRouterDeleteFeaturedContentResponse>(
    getAppsAdvApiRouterDeleteFeaturedContentUrl(contentId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

/**
 * Reorder featured content (admin only).
 * @summary Reorder Featured Content
 */
export type appsAdvApiRouterReorderFeaturedContentResponse200 = {
  data: FeaturedContentOut;
  status: 200;
};

export type appsAdvApiRouterReorderFeaturedContentResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsAdvApiRouterReorderFeaturedContentResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterReorderFeaturedContentResponseSuccess =
  appsAdvApiRouterReorderFeaturedContentResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterReorderFeaturedContentResponseError = (
  | appsAdvApiRouterReorderFeaturedContentResponse400
  | appsAdvApiRouterReorderFeaturedContentResponse403
) & {
  headers: Headers;
};

export type appsAdvApiRouterReorderFeaturedContentResponse =
  | appsAdvApiRouterReorderFeaturedContentResponseSuccess
  | appsAdvApiRouterReorderFeaturedContentResponseError;

export const getAppsAdvApiRouterReorderFeaturedContentUrl = (
  contentId: string,
) => {
  return `/api/featured-content/${contentId}/reorder/`;
};

export const appsAdvApiRouterReorderFeaturedContent = async (
  contentId: string,
  reorderIn: ReorderIn,
  options?: RequestInit,
): Promise<appsAdvApiRouterReorderFeaturedContentResponse> => {
  return customFetch<appsAdvApiRouterReorderFeaturedContentResponse>(
    getAppsAdvApiRouterReorderFeaturedContentUrl(contentId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(reorderIn),
    },
  );
};

/**
 * Toggle featured status (admin only).
 * @summary Toggle Featured
 */
export type appsAdvApiRouterToggleFeaturedResponse200 = {
  data: FeaturedContentOut;
  status: 200;
};

export type appsAdvApiRouterToggleFeaturedResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsAdvApiRouterToggleFeaturedResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsAdvApiRouterToggleFeaturedResponseSuccess =
  appsAdvApiRouterToggleFeaturedResponse200 & {
    headers: Headers;
  };
export type appsAdvApiRouterToggleFeaturedResponseError = (
  | appsAdvApiRouterToggleFeaturedResponse400
  | appsAdvApiRouterToggleFeaturedResponse403
) & {
  headers: Headers;
};

export type appsAdvApiRouterToggleFeaturedResponse =
  | appsAdvApiRouterToggleFeaturedResponseSuccess
  | appsAdvApiRouterToggleFeaturedResponseError;

export const getAppsAdvApiRouterToggleFeaturedUrl = (contentId: string) => {
  return `/api/featured-content/${contentId}/toggle-featured/`;
};

export const appsAdvApiRouterToggleFeatured = async (
  contentId: string,
  toggleFeaturedIn: ToggleFeaturedIn,
  options?: RequestInit,
): Promise<appsAdvApiRouterToggleFeaturedResponse> => {
  return customFetch<appsAdvApiRouterToggleFeaturedResponse>(
    getAppsAdvApiRouterToggleFeaturedUrl(contentId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(toggleFeaturedIn),
    },
  );
};

/**
 * List all published rich content with filtering and search.
 * @summary List Rich Content
 */
export type appsCoreApiRouterListRichContentResponse200 = {
  data: RichContentListOut[];
  status: 200;
};

export type appsCoreApiRouterListRichContentResponseSuccess =
  appsCoreApiRouterListRichContentResponse200 & {
    headers: Headers;
  };
export type appsCoreApiRouterListRichContentResponse =
  appsCoreApiRouterListRichContentResponseSuccess;

export const getAppsCoreApiRouterListRichContentUrl = (
  params?: AppsCoreApiRouterListRichContentParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/rich-content/?${stringifiedParams}`
    : `/api/rich-content/`;
};

export const appsCoreApiRouterListRichContent = async (
  params?: AppsCoreApiRouterListRichContentParams,
  options?: RequestInit,
): Promise<appsCoreApiRouterListRichContentResponse> => {
  return customFetch<appsCoreApiRouterListRichContentResponse>(
    getAppsCoreApiRouterListRichContentUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Get featured content across all types.
 * @summary Get Featured Content
 */
export type appsCoreApiRouterGetFeaturedContentResponse200 = {
  data: RichContentListOut[];
  status: 200;
};

export type appsCoreApiRouterGetFeaturedContentResponseSuccess =
  appsCoreApiRouterGetFeaturedContentResponse200 & {
    headers: Headers;
  };
export type appsCoreApiRouterGetFeaturedContentResponse =
  appsCoreApiRouterGetFeaturedContentResponseSuccess;

export const getAppsCoreApiRouterGetFeaturedContentUrl = () => {
  return `/api/rich-content/featured/`;
};

export const appsCoreApiRouterGetFeaturedContent = async (
  options?: RequestInit,
): Promise<appsCoreApiRouterGetFeaturedContentResponse> => {
  return customFetch<appsCoreApiRouterGetFeaturedContentResponse>(
    getAppsCoreApiRouterGetFeaturedContentUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Create new rich content (authenticated users only).
 * @summary Create Rich Content
 */
export type appsCoreApiRouterCreateRichContentResponse201 = {
  data: RichContentDetailOut;
  status: 201;
};

export type appsCoreApiRouterCreateRichContentResponse400 = {
  data: AppsCoreApiRouterCreateRichContent400;
  status: 400;
};

export type appsCoreApiRouterCreateRichContentResponseSuccess =
  appsCoreApiRouterCreateRichContentResponse201 & {
    headers: Headers;
  };
export type appsCoreApiRouterCreateRichContentResponseError =
  appsCoreApiRouterCreateRichContentResponse400 & {
    headers: Headers;
  };

export type appsCoreApiRouterCreateRichContentResponse =
  | appsCoreApiRouterCreateRichContentResponseSuccess
  | appsCoreApiRouterCreateRichContentResponseError;

export const getAppsCoreApiRouterCreateRichContentUrl = () => {
  return `/api/rich-content/create/`;
};

export const appsCoreApiRouterCreateRichContent = async (
  richContentCreate: RichContentCreate,
  options?: RequestInit,
): Promise<appsCoreApiRouterCreateRichContentResponse> => {
  return customFetch<appsCoreApiRouterCreateRichContentResponse>(
    getAppsCoreApiRouterCreateRichContentUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(richContentCreate),
    },
  );
};

/**
 * Get a single rich content item by ID (published only).
 * @summary Get Rich Content
 */
export type appsCoreApiRouterGetRichContentResponse200 = {
  data: RichContentDetailOut;
  status: 200;
};

export type appsCoreApiRouterGetRichContentResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsCoreApiRouterGetRichContentResponseSuccess =
  appsCoreApiRouterGetRichContentResponse200 & {
    headers: Headers;
  };
export type appsCoreApiRouterGetRichContentResponseError =
  appsCoreApiRouterGetRichContentResponse404 & {
    headers: Headers;
  };

export type appsCoreApiRouterGetRichContentResponse =
  | appsCoreApiRouterGetRichContentResponseSuccess
  | appsCoreApiRouterGetRichContentResponseError;

export const getAppsCoreApiRouterGetRichContentUrl = (pk: number) => {
  return `/api/rich-content/${pk}/`;
};

export const appsCoreApiRouterGetRichContent = async (
  pk: number,
  options?: RequestInit,
): Promise<appsCoreApiRouterGetRichContentResponse> => {
  return customFetch<appsCoreApiRouterGetRichContentResponse>(
    getAppsCoreApiRouterGetRichContentUrl(pk),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Update rich content (owner only).
 * @summary Update Rich Content
 */
export type appsCoreApiRouterUpdateRichContentResponse200 = {
  data: RichContentDetailOut;
  status: 200;
};

export type appsCoreApiRouterUpdateRichContentResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsCoreApiRouterUpdateRichContentResponseSuccess =
  appsCoreApiRouterUpdateRichContentResponse200 & {
    headers: Headers;
  };
export type appsCoreApiRouterUpdateRichContentResponseError =
  appsCoreApiRouterUpdateRichContentResponse404 & {
    headers: Headers;
  };

export type appsCoreApiRouterUpdateRichContentResponse =
  | appsCoreApiRouterUpdateRichContentResponseSuccess
  | appsCoreApiRouterUpdateRichContentResponseError;

export const getAppsCoreApiRouterUpdateRichContentUrl = (pk: number) => {
  return `/api/rich-content/${pk}/update/`;
};

export const appsCoreApiRouterUpdateRichContent = async (
  pk: number,
  richContentUpdate: RichContentUpdate,
  options?: RequestInit,
): Promise<appsCoreApiRouterUpdateRichContentResponse> => {
  return customFetch<appsCoreApiRouterUpdateRichContentResponse>(
    getAppsCoreApiRouterUpdateRichContentUrl(pk),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(richContentUpdate),
    },
  );
};

/**
 * Delete rich content (owner only).
 * @summary Delete Rich Content
 */
export type appsCoreApiRouterDeleteRichContentResponse204 = {
  data: void;
  status: 204;
};

export type appsCoreApiRouterDeleteRichContentResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsCoreApiRouterDeleteRichContentResponseSuccess =
  appsCoreApiRouterDeleteRichContentResponse204 & {
    headers: Headers;
  };
export type appsCoreApiRouterDeleteRichContentResponseError =
  appsCoreApiRouterDeleteRichContentResponse404 & {
    headers: Headers;
  };

export type appsCoreApiRouterDeleteRichContentResponse =
  | appsCoreApiRouterDeleteRichContentResponseSuccess
  | appsCoreApiRouterDeleteRichContentResponseError;

export const getAppsCoreApiRouterDeleteRichContentUrl = (pk: number) => {
  return `/api/rich-content/${pk}/delete/`;
};

export const appsCoreApiRouterDeleteRichContent = async (
  pk: number,
  options?: RequestInit,
): Promise<appsCoreApiRouterDeleteRichContentResponse> => {
  return customFetch<appsCoreApiRouterDeleteRichContentResponse>(
    getAppsCoreApiRouterDeleteRichContentUrl(pk),
    {
      ...options,
      method: "DELETE",
    },
  );
};

/**
 * Get all published log book entries.
 * @summary Get Log Book Entries
 */
export type appsCoreApiRouterGetLogBookEntriesResponse200 = {
  data: RichContentListOut[];
  status: 200;
};

export type appsCoreApiRouterGetLogBookEntriesResponseSuccess =
  appsCoreApiRouterGetLogBookEntriesResponse200 & {
    headers: Headers;
  };
export type appsCoreApiRouterGetLogBookEntriesResponse =
  appsCoreApiRouterGetLogBookEntriesResponseSuccess;

export const getAppsCoreApiRouterGetLogBookEntriesUrl = () => {
  return `/api/log-book/`;
};

export const appsCoreApiRouterGetLogBookEntries = async (
  options?: RequestInit,
): Promise<appsCoreApiRouterGetLogBookEntriesResponse> => {
  return customFetch<appsCoreApiRouterGetLogBookEntriesResponse>(
    getAppsCoreApiRouterGetLogBookEntriesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Create a Stripe Checkout Session for subscription.

Returns the checkout URL that the client should redirect to.
The client_reference_id is set to the user's ID for webhook matching.

Rate limited to 10 requests per user per hour.
 * @summary Create Subscription Checkout
 */
export type appsBillingApiSubscriptionsCreateSubscriptionCheckoutResponse200 = {
  data: CheckoutSessionResponse;
  status: 200;
};

export type appsBillingApiSubscriptionsCreateSubscriptionCheckoutResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsBillingApiSubscriptionsCreateSubscriptionCheckoutResponse429 = {
  data: ErrorResponse;
  status: 429;
};

export type appsBillingApiSubscriptionsCreateSubscriptionCheckoutResponse500 = {
  data: ErrorResponse;
  status: 500;
};

export type appsBillingApiSubscriptionsCreateSubscriptionCheckoutResponseSuccess =
  appsBillingApiSubscriptionsCreateSubscriptionCheckoutResponse200 & {
    headers: Headers;
  };
export type appsBillingApiSubscriptionsCreateSubscriptionCheckoutResponseError =
  (
    | appsBillingApiSubscriptionsCreateSubscriptionCheckoutResponse400
    | appsBillingApiSubscriptionsCreateSubscriptionCheckoutResponse429
    | appsBillingApiSubscriptionsCreateSubscriptionCheckoutResponse500
  ) & {
    headers: Headers;
  };

export type appsBillingApiSubscriptionsCreateSubscriptionCheckoutResponse =
  | appsBillingApiSubscriptionsCreateSubscriptionCheckoutResponseSuccess
  | appsBillingApiSubscriptionsCreateSubscriptionCheckoutResponseError;

export const getAppsBillingApiSubscriptionsCreateSubscriptionCheckoutUrl =
  () => {
    return `/api/checkout/subscription/`;
  };

export const appsBillingApiSubscriptionsCreateSubscriptionCheckout = async (
  checkoutSessionRequest: CheckoutSessionRequest,
  options?: RequestInit,
): Promise<appsBillingApiSubscriptionsCreateSubscriptionCheckoutResponse> => {
  return customFetch<appsBillingApiSubscriptionsCreateSubscriptionCheckoutResponse>(
    getAppsBillingApiSubscriptionsCreateSubscriptionCheckoutUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(checkoutSessionRequest),
    },
  );
};

/**
 * Generate a Customer Portal session URL.

The Customer Portal allows users to manage their subscription,
update payment methods, and view billing history.
 * @summary Get Portal Url
 */
export type appsBillingApiSubscriptionsGetPortalUrlResponse200 = {
  data: PortalUrlResponse;
  status: 200;
};

export type appsBillingApiSubscriptionsGetPortalUrlResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsBillingApiSubscriptionsGetPortalUrlResponse500 = {
  data: ErrorResponse;
  status: 500;
};

export type appsBillingApiSubscriptionsGetPortalUrlResponseSuccess =
  appsBillingApiSubscriptionsGetPortalUrlResponse200 & {
    headers: Headers;
  };
export type appsBillingApiSubscriptionsGetPortalUrlResponseError = (
  | appsBillingApiSubscriptionsGetPortalUrlResponse400
  | appsBillingApiSubscriptionsGetPortalUrlResponse500
) & {
  headers: Headers;
};

export type appsBillingApiSubscriptionsGetPortalUrlResponse =
  | appsBillingApiSubscriptionsGetPortalUrlResponseSuccess
  | appsBillingApiSubscriptionsGetPortalUrlResponseError;

export const getAppsBillingApiSubscriptionsGetPortalUrlUrl = (
  params?: AppsBillingApiSubscriptionsGetPortalUrlParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/billing/portal-url/?${stringifiedParams}`
    : `/api/billing/portal-url/`;
};

export const appsBillingApiSubscriptionsGetPortalUrl = async (
  params?: AppsBillingApiSubscriptionsGetPortalUrlParams,
  options?: RequestInit,
): Promise<appsBillingApiSubscriptionsGetPortalUrlResponse> => {
  return customFetch<appsBillingApiSubscriptionsGetPortalUrlResponse>(
    getAppsBillingApiSubscriptionsGetPortalUrlUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Create a Stripe Connect Express account and return an AccountLink URL for onboarding.

If the user already has a Connect account, generates a new AccountLink for that account.
The account ID is stored on User.stripe_connect_account_id after creation.
 * @summary Create Connect Onboarding Url
 */
export type appsBillingApiConnectCreateConnectOnboardingUrlResponse200 = {
  data: ConnectOnboardingResponse;
  status: 200;
};

export type appsBillingApiConnectCreateConnectOnboardingUrlResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsBillingApiConnectCreateConnectOnboardingUrlResponse500 = {
  data: ErrorResponse;
  status: 500;
};

export type appsBillingApiConnectCreateConnectOnboardingUrlResponseSuccess =
  appsBillingApiConnectCreateConnectOnboardingUrlResponse200 & {
    headers: Headers;
  };
export type appsBillingApiConnectCreateConnectOnboardingUrlResponseError = (
  | appsBillingApiConnectCreateConnectOnboardingUrlResponse400
  | appsBillingApiConnectCreateConnectOnboardingUrlResponse500
) & {
  headers: Headers;
};

export type appsBillingApiConnectCreateConnectOnboardingUrlResponse =
  | appsBillingApiConnectCreateConnectOnboardingUrlResponseSuccess
  | appsBillingApiConnectCreateConnectOnboardingUrlResponseError;

export const getAppsBillingApiConnectCreateConnectOnboardingUrlUrl = () => {
  return `/api/connect/onboarding-url/`;
};

export const appsBillingApiConnectCreateConnectOnboardingUrl = async (
  connectOnboardingRequest: ConnectOnboardingRequest,
  options?: RequestInit,
): Promise<appsBillingApiConnectCreateConnectOnboardingUrlResponse> => {
  return customFetch<appsBillingApiConnectCreateConnectOnboardingUrlResponse>(
    getAppsBillingApiConnectCreateConnectOnboardingUrlUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(connectOnboardingRequest),
    },
  );
};

/**
 * Create a Stripe Checkout Session for purchasing a rally ticket.

Uses Stripe Connect to route payment to the event organizer's
connected account, with a platform fee deducted.

Returns 400 if:
- User already has a ticket for this event
- Event organizer doesn't have an enabled Connect account
- Requested tier doesn't exist

Returns the checkout URL that the client should redirect to.

Rate limited to 10 requests per user per hour.
 * @summary Create Rally Ticket Checkout
 */
export type appsBillingApiTicketsCreateRallyTicketCheckoutResponse200 = {
  data: RallyTicketCheckoutResponse;
  status: 200;
};

export type appsBillingApiTicketsCreateRallyTicketCheckoutResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsBillingApiTicketsCreateRallyTicketCheckoutResponse429 = {
  data: ErrorResponse;
  status: 429;
};

export type appsBillingApiTicketsCreateRallyTicketCheckoutResponse500 = {
  data: ErrorResponse;
  status: 500;
};

export type appsBillingApiTicketsCreateRallyTicketCheckoutResponseSuccess =
  appsBillingApiTicketsCreateRallyTicketCheckoutResponse200 & {
    headers: Headers;
  };
export type appsBillingApiTicketsCreateRallyTicketCheckoutResponseError = (
  | appsBillingApiTicketsCreateRallyTicketCheckoutResponse400
  | appsBillingApiTicketsCreateRallyTicketCheckoutResponse429
  | appsBillingApiTicketsCreateRallyTicketCheckoutResponse500
) & {
  headers: Headers;
};

export type appsBillingApiTicketsCreateRallyTicketCheckoutResponse =
  | appsBillingApiTicketsCreateRallyTicketCheckoutResponseSuccess
  | appsBillingApiTicketsCreateRallyTicketCheckoutResponseError;

export const getAppsBillingApiTicketsCreateRallyTicketCheckoutUrl = (
  eventId: string,
) => {
  return `/api/checkout/rally-ticket/${eventId}/`;
};

export const appsBillingApiTicketsCreateRallyTicketCheckout = async (
  eventId: string,
  rallyTicketCheckoutRequest: RallyTicketCheckoutRequest,
  options?: RequestInit,
): Promise<appsBillingApiTicketsCreateRallyTicketCheckoutResponse> => {
  return customFetch<appsBillingApiTicketsCreateRallyTicketCheckoutResponse>(
    getAppsBillingApiTicketsCreateRallyTicketCheckoutUrl(eventId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(rallyTicketCheckoutRequest),
    },
  );
};

/**
 * Process a refund for a rally ticket.

Only admin users or the event host (host_user or created_by) can process refunds.
Refund amount is calculated based on the event's refund policy and days until the event.

Returns 403 if user doesn't have permission.
Returns 400 if ticket is not in a refundable state.
Returns 404 if ticket not found.
 * @summary Process Ticket Refund
 */
export type appsBillingApiTicketsProcessTicketRefundResponse200 = {
  data: RefundResponse;
  status: 200;
};

export type appsBillingApiTicketsProcessTicketRefundResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsBillingApiTicketsProcessTicketRefundResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type appsBillingApiTicketsProcessTicketRefundResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsBillingApiTicketsProcessTicketRefundResponse500 = {
  data: ErrorResponse;
  status: 500;
};

export type appsBillingApiTicketsProcessTicketRefundResponseSuccess =
  appsBillingApiTicketsProcessTicketRefundResponse200 & {
    headers: Headers;
  };
export type appsBillingApiTicketsProcessTicketRefundResponseError = (
  | appsBillingApiTicketsProcessTicketRefundResponse400
  | appsBillingApiTicketsProcessTicketRefundResponse403
  | appsBillingApiTicketsProcessTicketRefundResponse404
  | appsBillingApiTicketsProcessTicketRefundResponse500
) & {
  headers: Headers;
};

export type appsBillingApiTicketsProcessTicketRefundResponse =
  | appsBillingApiTicketsProcessTicketRefundResponseSuccess
  | appsBillingApiTicketsProcessTicketRefundResponseError;

export const getAppsBillingApiTicketsProcessTicketRefundUrl = (
  ticketId: string,
) => {
  return `/api/tickets/${ticketId}/refund/`;
};

export const appsBillingApiTicketsProcessTicketRefund = async (
  ticketId: string,
  options?: RequestInit,
): Promise<appsBillingApiTicketsProcessTicketRefundResponse> => {
  return customFetch<appsBillingApiTicketsProcessTicketRefundResponse>(
    getAppsBillingApiTicketsProcessTicketRefundUrl(ticketId),
    {
      ...options,
      method: "POST",
    },
  );
};

/**
 * Get all tickets purchased by the authenticated user.

Returns tickets ordered by purchase date (most recent first).
 * @summary Get My Tickets
 */
export type appsBillingApiTicketsGetMyTicketsResponse200 = {
  data: TicketListResponse;
  status: 200;
};

export type appsBillingApiTicketsGetMyTicketsResponse500 = {
  data: ErrorResponse;
  status: 500;
};

export type appsBillingApiTicketsGetMyTicketsResponseSuccess =
  appsBillingApiTicketsGetMyTicketsResponse200 & {
    headers: Headers;
  };
export type appsBillingApiTicketsGetMyTicketsResponseError =
  appsBillingApiTicketsGetMyTicketsResponse500 & {
    headers: Headers;
  };

export type appsBillingApiTicketsGetMyTicketsResponse =
  | appsBillingApiTicketsGetMyTicketsResponseSuccess
  | appsBillingApiTicketsGetMyTicketsResponseError;

export const getAppsBillingApiTicketsGetMyTicketsUrl = () => {
  return `/api/my-tickets/`;
};

export const appsBillingApiTicketsGetMyTickets = async (
  options?: RequestInit,
): Promise<appsBillingApiTicketsGetMyTicketsResponse> => {
  return customFetch<appsBillingApiTicketsGetMyTicketsResponse>(
    getAppsBillingApiTicketsGetMyTicketsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Get a ticket by its Stripe Checkout Session ID.

Used after successful checkout to display ticket details.
Only returns tickets owned by the authenticated user.
 * @summary Get Ticket By Session
 */
export type appsBillingApiTicketsGetTicketBySessionResponse200 = {
  data: TicketWithEventResponse;
  status: 200;
};

export type appsBillingApiTicketsGetTicketBySessionResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsBillingApiTicketsGetTicketBySessionResponse500 = {
  data: ErrorResponse;
  status: 500;
};

export type appsBillingApiTicketsGetTicketBySessionResponseSuccess =
  appsBillingApiTicketsGetTicketBySessionResponse200 & {
    headers: Headers;
  };
export type appsBillingApiTicketsGetTicketBySessionResponseError = (
  | appsBillingApiTicketsGetTicketBySessionResponse404
  | appsBillingApiTicketsGetTicketBySessionResponse500
) & {
  headers: Headers;
};

export type appsBillingApiTicketsGetTicketBySessionResponse =
  | appsBillingApiTicketsGetTicketBySessionResponseSuccess
  | appsBillingApiTicketsGetTicketBySessionResponseError;

export const getAppsBillingApiTicketsGetTicketBySessionUrl = (
  sessionId: string,
) => {
  return `/api/tickets/by-session/${sessionId}/`;
};

export const appsBillingApiTicketsGetTicketBySession = async (
  sessionId: string,
  options?: RequestInit,
): Promise<appsBillingApiTicketsGetTicketBySessionResponse> => {
  return customFetch<appsBillingApiTicketsGetTicketBySessionResponse>(
    getAppsBillingApiTicketsGetTicketBySessionUrl(sessionId),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Get a fresh signed URL for the ticket's QR code.

The URL expires in 15 minutes. Only the ticket owner can access this.
 * @summary Get Ticket Qr Url
 */
export type appsBillingApiTicketsGetTicketQrUrlResponse200 = {
  data: TicketQRUrlResponse;
  status: 200;
};

export type appsBillingApiTicketsGetTicketQrUrlResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type appsBillingApiTicketsGetTicketQrUrlResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type appsBillingApiTicketsGetTicketQrUrlResponse500 = {
  data: ErrorResponse;
  status: 500;
};

export type appsBillingApiTicketsGetTicketQrUrlResponseSuccess =
  appsBillingApiTicketsGetTicketQrUrlResponse200 & {
    headers: Headers;
  };
export type appsBillingApiTicketsGetTicketQrUrlResponseError = (
  | appsBillingApiTicketsGetTicketQrUrlResponse400
  | appsBillingApiTicketsGetTicketQrUrlResponse404
  | appsBillingApiTicketsGetTicketQrUrlResponse500
) & {
  headers: Headers;
};

export type appsBillingApiTicketsGetTicketQrUrlResponse =
  | appsBillingApiTicketsGetTicketQrUrlResponseSuccess
  | appsBillingApiTicketsGetTicketQrUrlResponseError;

export const getAppsBillingApiTicketsGetTicketQrUrlUrl = (ticketId: string) => {
  return `/api/tickets/${ticketId}/qr-url/`;
};

export const appsBillingApiTicketsGetTicketQrUrl = async (
  ticketId: string,
  options?: RequestInit,
): Promise<appsBillingApiTicketsGetTicketQrUrlResponse> => {
  return customFetch<appsBillingApiTicketsGetTicketQrUrlResponse>(
    getAppsBillingApiTicketsGetTicketQrUrlUrl(ticketId),
    {
      ...options,
      method: "GET",
    },
  );
};
